import { render, staticRenderFns } from "./CBProposalOutsideLimit.vue?vue&type=template&id=1ecc01df"
import script from "./CBProposalOutsideLimit.vue?vue&type=script&lang=js"
export * from "./CBProposalOutsideLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports